import { SHIPPING_STATUS_CODES } from '../../common/constants'

export const STATUS_CODE_FILTER_ORDER = [
  SHIPPING_STATUS_CODES.manifested,
  SHIPPING_STATUS_CODES.collected,
  SHIPPING_STATUS_CODES.inTransit,
  SHIPPING_STATUS_CODES.delivering,
  SHIPPING_STATUS_CODES.pudo,
  SHIPPING_STATUS_CODES.delivered,
  SHIPPING_STATUS_CODES.returned,
  SHIPPING_STATUS_CODES.cancelled,
]
